import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValidationMessages } from './control-validation-messages.component';
import { RequiredIntegerValidator } from './required-integer-validator.directive';
import { PositiveNumberValidator } from './positive-number-validator.directive';
import { MinimumDateValidator } from './minimum-date-validator.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ControlValidationMessages,
        RequiredIntegerValidator,
        PositiveNumberValidator,
        MinimumDateValidator
    ],
    exports: [
        ControlValidationMessages,
        RequiredIntegerValidator,
        PositiveNumberValidator,
        MinimumDateValidator
    ]
})
export class SharedValidatorsModule {}
